import { useContext } from 'react'

import { Box, BoxProps, Transition } from '@mantine/core'
import { useIntl } from 'react-intl'
import { shallow } from 'zustand/shallow'

import { useAirPopulationStore } from 'state/airPopulation'

import useStyles from './index.styles'
import { AirPopulationContext } from '../context'
import { ErrorScreenGeneral } from '../ErrorScreenGeneral'
import { ErrorScreenNotFoundResult } from '../ErrorScreenNotFoundResult'
import { Form } from '../Form'

const transition = {
  in: { opacity: 1, transform: 'translateY(0)' },
  out: { opacity: 0, transform: 'translateY(30%)' },
  transitionProperty: 'transform, opacity',
}

export const Body = ({
  className,
  styles,
  classNames,
  ...restProps
}: BoxProps) => {
  const {
    notShareLocationErr,
    notLoadResultError,
    backgroundColor,
    size,
  } = useContext(AirPopulationContext)
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(
    { size, backgroundColor },
    {
      name: 'AirPopulation__Body',
      styles,
      classNames,
    },
  )
  const { errorInitLoad } = useAirPopulationStore(
    (state) => ({
      errorInitLoad: state.error,
    }),
    shallow,
  )
  const hasInitError = typeof errorInitLoad === 'string'
  const hasResultError = typeof notLoadResultError === 'string'

  return (
    <Box
      {...restProps}
      className={cx(classes.root, className, 'air-population-body')}
    >
      <Box className={classes.inner}>
        <Transition
          keepMounted
          mounted={!hasInitError && !hasResultError}
          transition={transition}
        >
          {(styles) => (
            <Box className="chart-screen" style={styles}>
              <Form />
            </Box>
          )}
        </Transition>
        <Transition mounted={hasInitError} keepMounted transition={transition}>
          {(styles) => (
            <Box style={styles} className="error-screen">
              <ErrorScreenGeneral
                classNames={{ root: classes.errorScreenRoot }}
              />
            </Box>
          )}
        </Transition>
        <Transition
          mounted={hasResultError || notShareLocationErr}
          transition={transition}
        >
          {(styles) => (
            <Box style={styles} className="error-screen">
              <ErrorScreenNotFoundResult
                classNames={{ root: classes.errorScreenRoot }}
                message={
                  notShareLocationErr
                    ? f({
                        id: 'airPopulation.notShareLocation.error',
                        defaultMessage:
                          'Cannot find your location. Please try again.',
                      })
                    : ''
                }
              />
            </Box>
          )}
        </Transition>
      </Box>
    </Box>
  )
}
